import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Loader2, AlertTriangle } from 'lucide-react';
import SEAReportPdfPreview from '../components/sea/SEAReportPdfPreview';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PublicSEAReport() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios.get(`${API}/public/sea-report/${token}`)
      .then(({ data }) => setData(data))
      .catch(e => setError(e.response?.data?.detail || 'Lien invalide'));
  }, [token]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-neutral-50">
        <div className="bg-white border border-red-200 rounded-lg p-8 max-w-md text-center">
          <AlertTriangle className="w-10 h-10 text-red-500 mx-auto mb-3" />
          <h1 className="text-lg font-bold text-neutral-900 mb-1">Rapport indisponible</h1>
          <p className="text-sm text-neutral-600">{error}</p>
        </div>
      </div>
    );
  }
  if (!data) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-neutral-50">
        <Loader2 className="w-8 h-8 animate-spin text-[#002FA7]" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-neutral-100 py-8" data-testid="public-sea-report-page">
      <div className="max-w-5xl mx-auto px-4">
        <SEAReportPdfPreview publicData={data} />
      </div>
    </div>
  );
}
